/**
 * Configuração Global do Site
 * Este arquivo contém todas as configurações visuais e textuais do site
 * Modifique os valores conforme necessário
 */

export const siteConfig = {
    /**
     * Informações Básicas do Site
     * Modifique estas informações para alterar os títulos e textos principais
     */
    site: {
      // Nome que aparece na aba do navegador
      name: "Ziphius 3D Quotes",
      
      // Título principal (primeira linha do cabeçalho)
      title1: "Ziphius",
      
      // Subtítulo (segunda linha do cabeçalho)
      title2: "3D Quotes",
      
      // Descrição do site (usado para SEO)
      description: "Sistema de Orçamentos para Impressão 3D",
    },
  
    /**
     * Configurações do Rodapé
     * Modifique estas informações para personalizar o rodapé
     */
    footer: {
      // Texto do copyright
      copyrightText: "Ziphius 3D Quotes",
      
      // Nome do desenvolvedor/empresa
      developerName: "Luis \"Skedar\" Rizzi",
      
      // Link do desenvolvedor/empresa
      developerLink: "https://skedar.github.io/",
    },
  
    /**
     * Configurações de Idioma
     * [ESTRUTURA] Será implementado posteriormente
     * Não modifique esta seção ainda
     */
    language: {
      // Idioma padrão
      default: "pt-BR",
      
      // Idiomas disponíveis
      available: ["pt-BR", "en-US"],
    },
  
    /**
     * Configurações de Tema
     * Escolha o tema visual do site
     */
    theme: {
      // Nome do tema atual
      // Opções disponíveis: 'space', 'modern', aurora e custom
      // Utilize o tema 'custom' para criar seu próprio tema
      name: "space",
    },
  
    /**
     * Configurações de Contato
     * Informações usadas no formulário e emails
     */
    contact: {
      // Email para onde serão enviados os orçamentos
      email: "contato@empresa.com",
      
      // Telefone de contato (opcional)
      phone: "(00) 0000-0000",
    },
  
    /**
     * Configurações de Redes Sociais
     * Adicione ou remova conforme necessário
     */
    socialMedia: {
      instagram: "https://instagram.com/sua-empresa",
      facebook: "https://facebook.com/sua-empresa",
      // Adicione outras redes sociais conforme necessário
    }
  };
  
  /**
   * IMPORTANTE:
   * 1. Modifique apenas os valores, não as chaves
   * 2. Mantenha o formato e a estrutura do arquivo
   * 3. Faça backup antes de modificar
   */
  
  // Exporta a configuração para uso no projeto
  export type SiteConfig = typeof siteConfig;
  export default siteConfig;